import {
  Block,
  isTypeForBlockWithChildren,
} from '@basehub/data/replicache/index'
import { NodeViewProps, NodeViewWrapper } from '@tiptap/react'
import { BlockIcon } from '~/components/block-icon'

import { getBlockTitleForDisplay } from '~/lib/get-block-title-for-display'
import { TreeNode } from '@basehub/utils/tree/index'
import { ErrorBoundary } from 'react-error-boundary'
import { ButtonLink } from '~/sotano-kit/primitives/button'

export const BlockMentionNodeView = ({
  node,
  getNode,
}: NodeViewProps & {
  getNode: (id: string) => TreeNode<Block> | undefined
}) => {
  const treeNode = getNode?.(node.attrs.id)
  const dataBlock = node.attrs['block-type'] as Block['type'] | undefined

  // const url = https://basehub.com/[team-slug]/[repo-slug]/explorer/[block-id]
  // could be dynamic obtain from pos
  const teamSlug = window.location.pathname.split('/')[1]
  const repoSlug = window.location.pathname.split('/')[2]
  const branchSlug = window.location.pathname.split('/')[4] || 'main'
  let blockSegment = treeNode?.value?.id ?? node.attrs.id
  if (
    treeNode &&
    treeNode.value &&
    !isTypeForBlockWithChildren(treeNode.value.type)
  ) {
    blockSegment = `${treeNode.parentKey}#${blockSegment}`
  }
  const url = `/${teamSlug}/${repoSlug}/explore/${branchSlug}/${blockSegment}`

  return (
    <NodeViewWrapper
      contentEditable={false}
      className="inline-flex items-center cursor-default align-bottom select-none"
    >
      <ErrorBoundary
        fallback={
          <span className="inline-flex items-center cursor-default align-bottom gap-0.5 hover:bg-dark-elevated bg-dark-shade-hover border border-dark-border-solid rounded px-1 text-dark-bright text-xs light:bg-dark-shade light:hover:bg-dark-shade-hover">
            Deleted block
          </span>
        }
      >
        <ButtonLink
          unstyled
          focusStyled
          href={url}
          className="inline-flex items-center cursor-default align-bottom gap-0.5 hover:bg-dark-elevated bg-dark-shade-hover border border-dark-border-solid rounded px-1 text-dark-bright text-xs light:bg-dark-shade light:hover:bg-dark-shade-hover"
        >
          <ErrorBoundary fallback={null}>
            <BlockIcon
              iconProps={{ className: 'size-3.5 shrink-0' }}
              block={{ type: treeNode?.value?.type ?? dataBlock ?? 'instance' }}
            />
          </ErrorBoundary>
          <span className="flex-1 truncate max-w-[25ch] text-nowrap whitespace-nowrap font-medium">
            {getBlockTitleForDisplay(
              treeNode?.value?.title ?? node.attrs.label ?? 'Untitled'
            )}
          </span>
        </ButtonLink>
      </ErrorBoundary>
    </NodeViewWrapper>
  )
}
